import Vue from 'vue';

export default Vue.component('section-waveone-divider', {
  template: require('./template.html'),
  name: 'section-waveone-divider',
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/section/components/shape-dividers/wave-one/index.js